import { render } from "./errorPage.vue?vue&type=template&id=730eaec6"
const script = {}

import "./errorPage.vue?vue&type=style&index=0&id=730eaec6&lang=less&scope=true"

import exportComponent from "C:\\Users\\PC\\AppData\\Local\\Temp\\tecs-enduser-release-cd96384e-20260902-1753\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__